import PropTypes from 'prop-types';
import Card from "../../Card/Card";
import CardSection from "../../Card/CardSection";
import EligibilityItem from "./EligibilityItem";
import EligibilityRequirements from "./EligibilityRequirements";
import Icon from "../../Icon/Icon";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const DISPLAY_NAME = 'program-detail-eligibility-type';
const eligibilityItem = item => item.map(_ref => {
  let {
    visibility,
    title,
    options
  } = _ref;
  return /*#__PURE__*/_jsx(EligibilityItem, {
    visibility: visibility,
    title: title,
    options: options
  }, title);
});
function Eligibility(_ref2) {
  let {
    eligibilityRef,
    eligibilityText,
    populationSpecializations,
    populationRestrictions,
    paymentOptions,
    accessibilityOptions,
    deliveryOptions,
    transportationOptions,
    cityRequirements,
    countyRequirements,
    stateRequirements,
    ageSpecializations,
    genderRequirements,
    ageRequirements,
    postalCodeRequirements,
    languages,
    hasRequirements,
    hasAccessibility,
    hasOtherEligibility,
    hasEligibility,
    showRequiresFeeScheduleScreening
  } = _ref2;
  const accessibility = [{
    visibility: !!deliveryOptions,
    title: 'Program Delivery',
    options: deliveryOptions
  }, {
    visibility: !!languages,
    title: 'Supported Languages',
    options: languages
  }, {
    visibility: !!populationSpecializations,
    title: 'Populations Specialized In',
    options: populationSpecializations
  }, {
    visibility: !!ageSpecializations,
    title: 'Ages Specialized In',
    options: ageSpecializations
  }, {
    visibility: !!accessibilityOptions,
    title: 'Accessibility Services',
    options: accessibilityOptions
  }, {
    visibility: !!transportationOptions,
    title: 'Transportation Options',
    options: transportationOptions
  }, {
    visibility: !!paymentOptions,
    title: 'Payment Options',
    options: paymentOptions
  }];
  const accessbilityList = eligibilityItem(accessibility);
  return hasEligibility && /*#__PURE__*/_jsxs(Card, {
    ref: eligibilityRef,
    title: "Program Criteria",
    className: "border border-solid rounded border-med-pale-blue bg-white mb-6",
    children: [showRequiresFeeScheduleScreening && /*#__PURE__*/_jsxs("div", {
      className: "d-block m-4 leading-normal",
      children: [/*#__PURE__*/_jsx(Icon, {
        icon: "ExclamationTriangle",
        className: "pr-1",
        color: "#182A44"
      }), /*#__PURE__*/_jsx("span", {
        className: "align-middle font-medium-font",
        children: "Requires specialized screening: "
      }), /*#__PURE__*/_jsx("span", {
        className: "align-middle",
        children: "This program requires that the client complete a specialized screening before receiving services. To find resources that offer specialized screenings, use the Offers Specialized Screening filter."
      })]
    }), hasRequirements && /*#__PURE__*/_jsx(CardSection, {
      title: "Eligibility Requirements:",
      className: "border-b border-solid border-med-pale-blue p-3",
      children: /*#__PURE__*/_jsx(EligibilityRequirements, {
        populationRestrictions: populationRestrictions,
        cityRequirements: cityRequirements,
        countyRequirements: countyRequirements,
        stateRequirements: stateRequirements,
        genderRequirements: genderRequirements,
        ageRequirements: ageRequirements,
        postalCodeRequirements: postalCodeRequirements
      })
    }), hasOtherEligibility && /*#__PURE__*/_jsx(CardSection, {
      title: "Other Eligibility Requirements:",
      className: "border-b border-solid border-med-pale-blue p-3",
      children: /*#__PURE__*/_jsx("div", {
        className: "mx-4",
        children: /*#__PURE__*/_jsx("p", {
          dangerouslySetInnerHTML: {
            __html: eligibilityText
          }
        })
      })
    }), hasAccessibility && /*#__PURE__*/_jsx(CardSection, {
      title: "Accessibility and Specializations:",
      className: "border-b border-solid border-med-pale-blue p-3",
      children: /*#__PURE__*/_jsx("div", {
        className: "mx-4",
        children: /*#__PURE__*/_jsx("ul", {
          className: `${DISPLAY_NAME}-list list-disc pl-2`,
          children: accessbilityList
        })
      })
    })]
  });
}
Eligibility.propTypes = {
  eligibilityRef: PropTypes.shape({
    current: PropTypes.element
  }).isRequired,
  eligibilityText: PropTypes.string,
  populationSpecializations: PropTypes.string.isRequired,
  populationRestrictions: PropTypes.string.isRequired,
  paymentOptions: PropTypes.string.isRequired,
  accessibilityOptions: PropTypes.string.isRequired,
  deliveryOptions: PropTypes.string.isRequired,
  transportationOptions: PropTypes.string.isRequired,
  cityRequirements: PropTypes.string.isRequired,
  countyRequirements: PropTypes.string.isRequired,
  stateRequirements: PropTypes.string.isRequired,
  ageSpecializations: PropTypes.string.isRequired,
  genderRequirements: PropTypes.string.isRequired,
  ageRequirements: PropTypes.string.isRequired,
  postalCodeRequirements: PropTypes.string.isRequired,
  languages: PropTypes.string.isRequired,
  hasRequirements: PropTypes.bool.isRequired,
  hasAccessibility: PropTypes.bool.isRequired,
  hasOtherEligibility: PropTypes.bool.isRequired,
  hasEligibility: PropTypes.bool.isRequired,
  showRequiresFeeScheduleScreening: PropTypes.bool.isRequired
};
Eligibility.defaultProps = {
  eligibilityText: ''
};
export default Eligibility;
//# sourceMappingURL=Eligibility.js.map